import { Observable } from "rxjs";

import { post , get, put} from "@utils/axios";
import sessionService from "./session.service";

class ReportService {

  getReportTableData({ payload }: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/getReportTableData`, {
      ...payload,
    });
  }

  getColumnsList(reportName : string): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/patient/column-list?pageName=${reportName}`);
  }

  downloadReport({reportName, columns , sortByCol , sortType , filters, topFilters} : any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/downloadReport` , {
      reportName,
      columns,
      sortByCol,
      sortType,
      topFilters,
      filters
    });
  }

  updateColumns(columns: any[], reportName: string): Observable<any> {
    return put(`${sessionService.getClient()?.appServiceUrl}/patient/column-preference?pageName=${reportName}`, { columns: columns });
  }

  downloadNotesReport(isAllCM: any, memberId?: any): Observable<any> {
    let param = `isAllCM=${isAllCM}`;
    if (memberId) {
      param = param + `&memberId=${memberId}`;
    }
    return get(`${sessionService.getClient()?.appServiceUrl}/report/download-notes?${param}`);
  }

  getHCCScoreCardData(startDate: any, endDate?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/hccReportScoreCard`, {
      startDate,
      endDate
    });
  }

  getChronicBreakdownChartData(state: any, city: any, healthPlan: any, pcpVendor: any, pcpId: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/chronicBreakdownReport`, {state, city, healthPlan, pcpVendor, pcpId});
  }

  exportChronicBreakdown(state: any, city: any, healthPlan: any, pcpVendor: any, pcpId: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/downloadChronicBreakdownReport`, {state, city, healthPlan, pcpVendor, pcpId});
  }

  getChronicBreakdownReportPatientIds(state: any, city: any, healthPlan: any, pcpVendor: any, pcpId: any, chronicName: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/report/chronicBreakdownReportPatientIds`, {state, city, healthPlan, pcpVendor, pcpId, chronicName});
  }
}

export default new ReportService();